/**
 * 描述：产品管理网站左侧导航
 * 日期：2017-7-23
 * 作者：Bai.Zhiming
 */
'use strict';
angular.module('productMgrWebsiteLeftModule', [])
    .directive('productMgrWebsiteLeft', ['productManageMentService', '$q', '$stateParams', '$timeout', '$location', 'modalDialog', 'trsHttpService', 'trsColumnTreeLocationService', 'productMangageMentWebsiteService', 'localStorageService', '$state', function(productManageMentService, $q, $stateParams, $timeout, $location, modalDialog, trsHttpService, trsColumnTreeLocationService, productMangageMentWebsiteService, localStorageService, $state) {
        return {
            restirct: 'A',
            scope: true,
            replace: false,
            templateUrl: './manageConfig/productManageMent/website/left/left_tpl.html',
            link: function($scope, iElm, iAttrs) {
                initStatus();
                initData();

                /**
                 * [initStatus description]初始化状态
                 * @param {[type]} [varname] [description]
                 * @return null [description]
                 */
                function initStatus() {
                    $scope.status = {
                        treeOpts: {
                            nodeChildren: 'CHILDREN',
                            dirSelectable: 'true',
                            allowDeselect: false,
                            templateUrl: '../app/components/htmlTemplates/treeTemplate.html',
                            isLeaf: function(node) {
                                return node.HASCHILDREN == 'false' && (angular.isUndefined(node.CHILDREN));
                            }
                        },
                        treeExpanded: []
                    };
                    $scope.showTree = true;
                    $scope.treeOpts = {};
                    $scope.data = [];
                    initDropDownListBlur();
                }

                /**
                 * [initDropDownListBlur description] 初始化下拉菜单失焦事件
                 * @return {[type]} [description]
                 */
                function initDropDownListBlur() {
                    $('html').unbind('click', myBlur).bind('click', myBlur);

                    function myBlur($event) {
                        var $target = $($event.target);
                        if ($target.parents('.content_nav_select').length === 0) {
                            $timeout(function() {
                                $scope.status.isdownPicShow = false;
                            });
                        }
                    }
                    $scope.$on('$destroy', function() {
                        $('html').unbind('click', myBlur);
                    });
                }

                /**
                 * [initSelectSite description]初始化选中站点
                 * @param {[type]} [varname] [description]
                 * @return null [description]
                 */
                function initSelectSite() {
                    var deffer = $q.defer();
                    var siteId = $stateParams.site;
                    if (angular.isDefined(siteId)) {
                        for (var i = 0; i < $scope.treedata.length; i++) {
                            if ($scope.treedata[i].SITEID === siteId) {
                                $scope.status.selectedWebsite = angular.copy($scope.treedata[i]);
                                break;
                            }
                        }
                        deffer.resolve();
                    } else {
                        $scope.status.selectedWebsite = angular.copy($scope.treedata[0]);
                    }
                    return deffer.promise;
                }

                /**
                 * [initData description]初始化数据
                 * @param {[type]} [varname] [description]
                 * @return null [description]
                 */
                function initData() {
                    initWebsiteData().then(function() {
                        return initSelectSite();
                    }).then(function() {
                        getChannelsBySite($scope.status.selectedWebsite).then(function(data) {
                            $scope.data.channelTreedata = data;
                            positionToChannel();
                        });
                    });
                }

                /**
                 * [initData description]进入站点
                 * @param {[type]} [varname] [description]
                 * @return null [description]
                 */
                function positionToSite() {
                    var siteId = $location.search().site;
                    for (var i = 0; i < $scope.treedata.length; i++) {
                        if ($scope.treedata[i].SITEID === siteId) {
                            $scope.status.selectedWebsite = angular.copy($scope.treedata[i]);
                            break;
                        }
                    }
                    $scope.selectWebsite();
                }

                /**
                 * [initData description]进入栏目
                 * @param {[type]} [varname] [description]
                 * @return null [description]
                 */
                function positionToChannel() {
                    $timeout(function() {
                        var channelId = $location.search().channel;
                        if (angular.isUndefined(channelId)) {return;}
                        var treeData = angular.copy($scope.status.selectedWebsite);
                        treeData.CHILDREN = angular.copy($scope.data.channelTreedata);
                        trsColumnTreeLocationService.columnTreeLocation(1, channelId, treeData, $scope.status.selectedNode, $scope.status.treeExpanded, function(tree, array, selectedNode) {
                            $scope.data.channelTreedata = tree.CHILDREN;
                            $scope.status.selectedNode = selectedNode;
                            $scope.showWebsiteToggle($scope.status.selectedNode).then(function() {
                                $scope.status.treeExpanded.push($scope.status.selectedNode);
                            });
                        });
                    }, 600);
                }

                /**
                 * [getChannelsBySite description]根据站点获取栏目
                 * @return null [description]
                 */
                function getChannelsBySite(node) {
                    var deffer = $q.defer();
                    var params;
                    params = {
                        serviceid: 'mlf_websiteconfig',
                        methodname: 'queryChannelsBySite',
                        siteid: node.SITEID,
                        platform: 4,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        for (var i = 0; i < data.length; i++) {
                            data[i].TOPCHNLID = data[i].CHANNELID;
                            data[i].SITEID = node.SITEID;
                        }

                        /* node.CHILDREN = data;*/
                        deffer.resolve(data);
                    });
                    return deffer.promise;
                }

                /**
                 * [showWebsiteToggle description]展开网站栏目频道树节点
                 * @return null [description]
                 */
                $scope.showWebsiteToggle = function(node) {
                    var deffer = $q.defer();
                    if (node.HASCHILDREN == 'true') {
                        getChannelsByChannel(node).then(function() {
                            deffer.resolve();
                        });
                    }
                    return deffer.promise;
                };

                /**
                 * [getChannelsByChannel description]根据父栏目获取栏目
                 * @return null [description]
                 */
                function getChannelsByChannel(node) {
                    var deffer = $q.defer();
                    var paramsChnl;
                    paramsChnl = {
                        serviceid: 'mlf_websiteconfig',
                        methodname: 'queryChannelsByChannel',
                        channelid: node.CHANNELID,
                        platform: 4,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), paramsChnl, 'get').then(function(data) {
                        for (var i = 0; i < data.length; i++) {
                            data[i].SITEID = node.SITEID;
                        }
                        deffer.resolve(node);
                        node.CHILDREN = data;
                    });
                    return deffer.promise;
                }

                /**
                 * [selectWebsite description]选择站点
                 * @return null [description]
                 */
                $scope.selectWebsite = function(site) {
                    $scope.status.selectedWebsite = !!site ? site : $scope.status.selectedWebsite;
                    if (angular.isUndefined($scope.status.selectedWebsite.SITEID)) {
                        $scope.goSiteMgr();
                        return;
                    }
                    $scope.showSelected($scope.status.selectedWebsite);
                    getChannelsBySite($scope.status.selectedWebsite).then(function(data) {
                        $scope.data.channelTreedata = data;
                    });
                };

                /**
                 * [showSelected description]选中栏目、频道节点
                 * @param {[sel]} [varname] [description] 节点对象
                 * @return null [description]
                 */
                $scope.showSelected = function(sel) {
                    $scope.status.selectedNode = sel;
                    if (!!sel.CHANNELID) {
                        productMangageMentWebsiteService.getCloumnAccessAuthority(sel.TOPCHNLID).then(function(data) {
                            // 將权限信息存入缓存，用于底部路由区加载使用开始
                            localStorageService.remove('rightOperType_channel'); // 初始化缓存
                            localStorageService.set('rightOperType_channel', {
                                type: data.router,
                                data: data.data
                            });
                            // 將权限信息存入缓存，用于底部路由区加载使用结束
                            $state.go('manageconfig.productmanage.website.' + data.router, {
                                channel: sel.CHANNELID,
                                parentchnl: sel.TOPCHNLID,
                                site: sel.SITEID,
                                status: sel.STATUS
                            }, { reload: 'manageconfig.productmanage.website.' + data.router });
                        });
                    } else {
                        productMangageMentWebsiteService.getChannelAccessAuthority(sel.SITEID).then(function(_data) {
                            // 將权限信息存入缓存，用于底部路由区加载使用开始
                            localStorageService.remove('rightOperType_site'); // 初始化缓存


                            // 测试添加 wf 
                            // var datawf = _data.data;
                            // datawf.watermarkMgr = {undefined: true};
                            // console.log((datawf));
                            // localStorageService.set("rightOperType_site", { "type": _data.router, "data": datawf});
                            // 测试添加 wf


                            // 原版暂时隐藏
                            localStorageService.set('rightOperType_site', { 'type': _data.router, 'data': _data.data });
                            // 將权限信息存入缓存，用于底部路由区加载使用结束
                            var url = 'manageconfig.productmanage.website.' + _data.router;
                            $state.go(url, { site: sel.SITEID, status: sel.STATUS }, { reload: url });

                            // $state.go("manageconfig.productmanage.website." + _data.router);
                        });
                    }
                };

                /**
                 * [initWebsiteData description]初始化网站数据
                 * @return null [description]
                 */
                function initWebsiteData() {
                    var deferred = $q.defer();
                    var params = {
                        'serviceid': 'mlf_websiteconfig',
                        'methodname': 'queryWebSitesForCloud',
                        'SiteDesc': $location.search().sitedesc,
                        'PAGESIZE': 2000
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        var siteData = data.DATA;
                        for (var i = 0; i < siteData.length; i++) {
                            siteData[i].name = siteData[i].SITEDESC;
                        }
                        siteData.unshift({
                            name: '--请选择站点--'
                        });
                        $scope.treedata = siteData;
                        deferred.resolve();
                    });
                    return deferred.promise;
                }

                /**
                 * [goSiteMgr description]进入站点管理
                 * @return null [description]
                 */
                $scope.goSiteMgr = function() {
                    $state.go('manageconfig.productmanage.website.site', { site: undefined }, { reload: true });
                };

                /**
                 * [goChnlMgr description]进入站点管理
                 * @return null [description]
                 */
                $scope.goChnlMgr = function() {
                    if ($scope.status.selectedWebsite.SITEID) {
                        $scope.showSelected($scope.status.selectedWebsite);
                        $scope.status.treeExpanded = [];
                    } else {
                        modalDialog.alertType('请先选择站点', '', 'info', false);
                    }
                };
            }
        };
    }]);
